/**
 * @description Check if an object is empty
 * @param objectName
 */
export const checkEmptyObject = (objectName: object): boolean => Object.keys(objectName).length === 0;
